<template>
    <div class="faq--wrapper">
        <h2>Frequently Asked Questions</h2>
        <LsAccordion :data="data"></LsAccordion>
        <Accordion v-if="shouldShowCallSupport" class="faq--additional-questions">
            <AccordionItem>
                <template slot="accordion-trigger">
                    <h3 :class="{ callSupportFontSize: callSupport }">
                        I have additional questions
                    </h3>
                </template>
                <template slot="accordion-content">
                    <li class="content">
                        <div>
                            <LsIconPhoneCall :width="21" :height="45" :color="green" />
                            <div class="header-text">
                                <span class="header-text-top">Have additional questions?</span>
                                <span class="header-text-description">Call Support</span>
                            </div>
                        </div>
                    </li>
                </template>
            </AccordionItem>
        </Accordion>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapState } from 'vuex';
import Accordion from '@/components/common/LsAccordion/accordion.vue';
import AccordionItem from '@/components/common/LsAccordion/accordion-item.vue';
import LsAccordion from '@/components/common/LsAccordion/LsAccordion.vue';
import LsIconPhoneCall from '@/components/general/icons/lsIconPhoneCall.vue';

export default {
    name: 'LsFAQ',
    components: {
        Accordion,
        AccordionItem,
        LsAccordion,
        LsIconPhoneCall,
    },
    props: {
        data: VueTypes.arrayOf(
            VueTypes.shape({
                title: VueTypes.string.isRequired,
                content: VueTypes.string.isRequired,
            }).isRequired
        ).isRequired,
        callSupport: VueTypes.bool.def(false),
    },
    data() {
        return {
            shouldShowCallSupport: false,
        };
    },
    computed: {
        ...mapState(['featureFlags']),
    },
    created() {
        this.shouldShowCallSupport =
            this.callSupport || this.featureFlags.flags.new_ltrs_flow_additional_questions;
    },
};
</script>

<style lang="scss" scoped>
.faq--wrapper {
    h2 {
        font-size: 13pt;
        font-weight: 600;
        color: $theme-color-primary;
        padding-bottom: 20px;
    }
    .faq--additional-questions {
        margin-top: 15px;
        h3 {
            font-weight: normal;
            padding-bottom: 12px;
            font-size: 14pt;
        }
        h3.callSupportFontSize {
            font-size: 12pt;
        }
        .content {
            padding: 5px;
            margin-top: 5px;
            background: $theme-color-primary-light;
            > div {
                display: flex;
                padding: 0.5rem;

                span {
                    font-size: 11pt;
                }
            }
            .header-text {
                margin-left: 1rem;
                @media (min-width: 300px) {
                    max-width: 370px;
                }
                .header-text-top {
                    display: flex;
                }
                .header-text-description {
                    font-weight: 700;
                }
            }
        }
    }
}
</style>
